import { IQuestion } from "../types/types"

export const sortByQuestionList = (list: string[], arr: IQuestion[]) => {
  const tmpMap = arr.reduce(
    (acc: { [key: string]: IQuestion }, item: IQuestion) => {
      acc[item.question_reference] = item
      return acc
    },
    {}
  )

  return list.map((key) => tmpMap[key])
}
